/* eslint-disable no-unused-vars */
/* global G, PLATFORM */
import { bulk, curry, setKey } from 'lib/util'
import sequenceComponentFindProxy from 'lib/sequence/component/children/find'
import { hide, show } from 'lib/sequence/component/state/hidden'
import { get, reset } from 'lib/sequence/component/state/value'
import { settings } from 'app/_shared/session'
import update from 'app/_shared/events/util/update'

/**
 * Reset Form Event Handler
 *
 * Resets the login form's components to their initial state.
 *
 * @param {Gaia.AppModule.Spec} module          app module
 * @param {Gaia.Component.Spec} component       action component
 * @param {Gaia.AppModule.EventHandler} event   event
 * @returns {void}
 */
const resetForm = (module, component, event) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { username, password, btnContinue, btnLogin } = sequenceComponentFindProxy(actionComponent)
  const bulkHide = bulk(hide)

  // clear previous errors
  setKey(false, G.ERROR, module[G.STATE])

  if (!settings.singleStepLogin && !get(username)) {
    reset(password)
    show(btnContinue)
    bulkHide(password, btnLogin)

    update(module, component, event)
  }
}

export default curry(resetForm)
